import { isLiveDashboardChart } from './liveDashboardDefaults'

export const LIVE_DASHBOARD_CURRENCY_CODES = ['USD', 'EUR', 'GBP']

const collectLeaves = (attributes) => {
  const leaves = []
  const walk = (nodes) => {
    for (const node of nodes || []) {
      if (node.Children?.length) {
        walk(node.Children)
      } else {
        leaves.push(node)
      }
    }
  }
  walk(attributes)
  return leaves
}

export const isCurrencyDimension = (dimension) => {
  const name = String(dimension?.Name ?? '')
  const display = String(dimension?.DisplayName ?? '').trim().toLowerCase()
  return name === 'ConversionID' || display === 'currency'
}

export const isLiveDashboardCurrencyDimension = (chart, dimension) =>
  isLiveDashboardChart(chart) && isCurrencyDimension(dimension)

const parseCurrencyCodeFromDisplayName = (displayName) => {
  const match = String(displayName ?? '').match(/^(USD|EUR|GBP)\b/i)
  return match ? match[1].toUpperCase() : null
}

/** Map USD / EUR / GBP to the Billion-scale ConversionID attribute used for API requests. */
export const buildCurrencyOptions = (dimension) => {
  const leaves = collectLeaves(dimension?.Attributes)
  const optionByCode = {}

  for (const leaf of leaves) {
    const code = parseCurrencyCodeFromDisplayName(leaf.DisplayName)
    if (!code || !LIVE_DASHBOARD_CURRENCY_CODES.includes(code)) {
      continue
    }

    const isBillion = /\bBillion\b/i.test(String(leaf.DisplayName ?? ''))
    const existing = optionByCode[code]
    if (!existing || isBillion) {
      optionByCode[code] = {
        code,
        attributeId: leaf.AttributeID,
        label: code,
      }
    }
  }

  return LIVE_DASHBOARD_CURRENCY_CODES
    .filter((code) => optionByCode[code])
    .map((code) => optionByCode[code])
}

export const parseCurrencySelectionToCode = (attributeIds, dimension) => {
  const selectedId = attributeIds?.[0]
  if (selectedId == null) {
    return 'USD'
  }

  const match = buildCurrencyOptions(dimension).find(
    (option) => option.attributeId === selectedId || String(option.attributeId) === String(selectedId),
  )
  return match?.code ?? 'USD'
}

export const findDefaultCurrencyAttributeId = (dimension) => {
  const usd = buildCurrencyOptions(dimension).find((option) => option.code === 'USD')
  return usd?.attributeId ?? buildCurrencyOptions(dimension)[0]?.attributeId ?? null
}

export const resolveCurrencyApiAttributeId = (currencyCode, dimension) => {
  const match = buildCurrencyOptions(dimension).find((option) => option.code === currencyCode)
  return match?.attributeId ?? findDefaultCurrencyAttributeId(dimension)
}
